<!--自动匹配库存-->
<template>
  <el-form ref="form" label-width="80px" size="mini">
    <div class="row-wrap" style="padding-left:30px;">
      <h4 style="padding-left:15px;">定时转寄设置</h4>
      <el-row>
        <el-col :xs="24" :sm="24" style="margin-top:-10px;margin-bottom:8px;">
          <el-link type="danger" disabled>
            {{ msg('每30分钟执行一次现货仓储和备货仓储的转寄') }}
          </el-link>
        </el-col>
        <el-col :xs="24">
          <el-form-item :label="msg('是否开启定时转寄：')" label-width="300">
            <el-radio v-model="autoInventory" label="1">是</el-radio>
            <el-radio v-model="autoInventory" label="0">否</el-radio>
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item :label="msg('选择仓库：')" label-width="300">
            <el-select v-model="storeId"  placeholder="请选择" size="small" multiple clearable @clear="clearStore">
                <el-option v-for="item in stores" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
    <div style="text-align:center; margin-top: 15px; margin-bottom:15px;">
      <el-button type="primary" size="mini" @click="update"><i class="el-icon-check"></i><span>{{ msg('确定') }}</span>
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "UserSettingTransportation",
  data() {
    return {
      xgroup: 'AUTO_INVENTORY_GROUP',  //自动匹配库存group
      autoInventory: 0, // 是否自动匹配库存
      autoInventoryObj: null, // 自动匹配库存对象
      storeId: null, // 仓库id
      stores: [], // 仓库列表
    }
  },
  mounted() {
    this.getSettings();
    this.getStores();
  },
  methods: {
    getStores(){
        this.$axios.post(this.$kit.api.store.listUsed)
            .then((result)=> {
                if(result.status){
                    this.stores = result.data;
                }
            });
    },
    clearStore(){
        this.storeId = null;
    },
    getSettings() {
      var _this = this;
      this.$axios.get(this.$kit.api.user.settingList + "?xgroup=" + this.xgroup)
          .then((result) => {
            if (result.status) {
              this.buildViewData(result.data); //构建设置对象
            }
          });
    },
    buildViewData(data) {
      var _this = this;
      if (data.length > 0) {
        // this.needUpdateTransport = data[0].xvalue;
        // this.needUpdateTransportObj = data[0];
        let inv = JSON.parse(data[0].xvalue);
        this.autoInventory = inv.autoInventory;
        this.storeId = inv.storeId;
      }
    },
    update() {
      if(!this.storeId && this.autoInventory==1){
        this.$message.error('请选择仓库');
        return;
      }
      
      let datas = [];
      if (this.autoInventoryObj) {
        this.autoInventoryObj.xvalue = JSON.stringify({
            autoInventory: this.autoInventory,
            storeId: this.storeId,
          }),
        datas.push(this.autoInventoryObj);
      } else {
        this.autoInventoryObj = {
          id: null,
          xkey: this.xgroup,
          owner: null,
          xgroup: this.xgroup,
          xvalue: JSON.stringify({
            autoInventory: this.autoInventory,
            storeId: this.storeId,
          }),
          xtype: 0
        }
        datas.push(this.autoInventoryObj);
      }

      var _this = this;
      _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + this.xgroup, datas).then((result) => {
        _this.$message(result.msg)
      });
    }
  }
}
</script>

<style scoped>

</style>